"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = void 0;
const env_1 = require("../env");
function isDataLayerReady() {
    return window?.google_tag_manager?.dataLayer?.gtmDom ?? false;
}
function attemptMigratePreDataLayer() {
    if (!isDataLayerReady() || !(0, env_1.isOnBrowser)()) {
        return; // don't migrate when it's not ready
    }
    window.__datalayer_pre = window.__datalayer_pre || [];
    if (window.__datalayer_pre.length > 0) {
        if (window.__datalayer_pre_interval_id) {
            window.clearInterval(window.__datalayer_pre_interval_id);
        }
        window.__datalayer_pre.forEach((prevItem) => window.dataLayer.push(prevItem));
        window.__datalayer_pre = []; // empty array
    }
    if (window.__datalayer_pre_interval_id) {
        window.clearInterval(window.__datalayer_pre_interval_id);
        window.__datalayer_pre_interval_id = null;
    }
}
if ((0, env_1.isOnBrowser)() && !window.__datalayer_pre_interval_id && !isDataLayerReady()) {
    window.__datalayer_pre_interval_id = window.setInterval(attemptMigratePreDataLayer, 500);
}
function pushToDataLayer(data) {
    window.__datalayer_pre = window.__datalayer_pre || [];
    // window.__gtm_state will initial be set to INITIAL and then changed to READY
    if (!isDataLayerReady()) {
        window.__datalayer_pre.push(data);
        return data;
    }
    attemptMigratePreDataLayer();
    // default
    window.dataLayer.push(data);
    return data;
}
// generic track function
function track(data) {
    if (!(0, env_1.isOnBrowser)()) {
        return data;
    }
    if (!window || !data) {
        // @ts-ignore
        return;
    }
    // if we don't have "event" field, complain
    if (!data.event) {
        console.error("[Tracking] missing 'event' field", data);
    }
    else {
        window.dataLayer = window.dataLayer || [];
        pushToDataLayer(data);
    }
    // log here
    return data;
}
exports.track = track;
